import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './roi/src/components/App';
import { setLanguage } from './roi/src/utils/translations';

const rootEl = document.getElementById('react-roi');

if (rootEl) {
    const jsonEl = rootEl.querySelector('script[type="application/json"]');
    const args = JSON.parse(jsonEl?.innerText || '{}');
    setLanguage(args.lang);
    ReactDOM.render(<App appArgs={args}/>, rootEl);
}
